export default "__VITE_ASSET__7K0rCumb__"